/** Small display helpers shared by every table, tile and card. */

export const money = (n, currency = 'AED') =>
  `${currency} ${Math.round(n || 0).toLocaleString('en-US')}`;

export const AVATAR_CLASSES = [
  'g-purple', 'g-green', 'g-amber', 'g-blue', 'g-cyan', 'g-pink', 'g-orange', 'g-red'
];

export const initials = n =>
  String(n || '?').replace(/[^A-Za-z0-9 ]/g, ' ').trim().split(/\s+/).slice(0, 2)
    .map(w => w[0]).join('').toUpperCase() || '?';

/** Stable colour per name, so the same person is always the same swatch. */
export const avatarClass = n =>
  AVATAR_CLASSES[Math.abs([...String(n || 'x')].reduce((a, c) => a + c.charCodeAt(0), 0)) % AVATAR_CLASSES.length];

export const lower = a => (a || []).map(x => String(x).toLowerCase());

export const digitsOf = p => String(p || '').replace(/[^0-9]/g, '');

export const whatsappLink = (phone, text) =>
  `https://wa.me/${digitsOf(phone)}?text=${encodeURIComponent(text || '')}`;

/** djb2 — enough to keep a PIN out of plain sight in settings. Not security. */
export function weakHash(str) {
  let h = 5381;
  for (let i = 0; i < str.length; i++) h = ((h << 5) + h + str.charCodeAt(i)) >>> 0;
  return String(h);
}

export const uid = prefix => `${prefix}-${Date.now()}-${Math.random().toString(36).slice(2, 7)}`;

/** Trigger a browser download for a Blob. */
export function download(blob, name) {
  const a = document.createElement('a');
  a.href = URL.createObjectURL(blob);
  a.download = name;
  a.click();
  setTimeout(() => URL.revokeObjectURL(a.href), 4000);
}

/**
 * A file as base64, without the `data:` prefix.
 *
 * Uploads go up inside ordinary JSON rather than as multipart: the app has no
 * upload middleware, and the things it accepts — a contact list, a picture for
 * an email — are small enough to sit in a request body.
 */
export const fileToBase64 = file => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.onload = () => resolve(String(reader.result).replace(/^data:[^,]*,/, ''));
  reader.onerror = () => reject(new Error('That file could not be read'));
  reader.readAsDataURL(file);
});

/**
 * 217 -> "3m 37s". How long somebody stayed, said the way a person says it.
 *
 * Seconds alone stop carrying meaning above a minute: "217s" is a number to
 * be divided, and the board is read at a glance. Shared by the pipeline row
 * and the deal sheet so the same visit cannot be described two ways.
 */
export function spent(seconds) {
  const n = Math.max(0, Math.round(seconds || 0));
  if (!n) return '';
  if (n < 60) return `${n}s`;
  const m = Math.floor(n / 60);
  const r = n % 60;
  return r ? `${m}m ${r}s` : `${m}m`;
}
